import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS } from "../lib/site";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="bg-brand-ink border-t border-brand-line">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
                    <div>
                        <Logo />
                        <p className="mt-5 text-brand-sage text-sm leading-relaxed max-w-xs">
                            Professional stump grinding and full cleanup for
                            Poplar Bluff, MO and a 30-mile radius. Ground 6–8
                            inches below grade, scheduled the same week you call.
                        </p>
                    </div>

                    <div className="space-y-4">
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-amber mb-6">
                            Contact
                        </p>
                        <a
                            href={BUSINESS.phoneTel}
                            data-testid="footer-phone-link"
                            className="flex items-center gap-3 text-brand-cream hover:text-brand-amber transition-colors font-semibold text-lg"
                        >
                            <Phone className="w-5 h-5 text-brand-amber" />
                            {BUSINESS.phoneDisplay}
                        </a>
                        <a
                            href={`mailto:${BUSINESS.email}`}
                            data-testid="footer-email-link"
                            className="flex items-center gap-3 text-brand-sage hover:text-brand-amber transition-colors break-all"
                        >
                            <Mail className="w-5 h-5 text-brand-amber shrink-0" />
                            {BUSINESS.email}
                        </a>
                        <p className="flex items-center gap-3 text-brand-sage text-sm">
                            <Clock className="w-5 h-5 text-brand-amber shrink-0" />
                            {BUSINESS.hours}
                        </p>
                        <p className="flex items-start gap-3 text-brand-sage text-sm">
                            <MapPin className="w-5 h-5 text-brand-amber shrink-0 mt-0.5" />
                            Based in Poplar Bluff, MO — serving a 30-mile radius
                        </p>
                    </div>

                    <div>
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-amber mb-6">
                            Site
                        </p>
                        <ul className="space-y-3">
                            {[
                                { label: "Home", to: "/" },
                                { label: "Pricing", to: "/pricing" },
                                { label: "Job Gallery", to: "/gallery" },
                                { label: "Free Quote", to: "/quote" },
                            ].map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="text-brand-sage hover:text-brand-amber transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-amber mt-8 mb-4">
                            We accept
                        </p>
                        <div className="flex flex-wrap gap-2">
                            {BUSINESS.payments.map((p) => (
                                <span
                                    key={p}
                                    className="font-mono text-[11px] uppercase tracking-wider border border-brand-line rounded-full px-3 py-1 text-brand-sage"
                                >
                                    {p}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="overflow-hidden border-t border-brand-line pt-8">
                    <p
                        aria-hidden="true"
                        className="font-display font-black uppercase text-[13vw] leading-[0.85] tracking-tight text-stroke-cream whitespace-nowrap select-none"
                    >
                        Southeast Stump
                    </p>
                </div>

                <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-brand-moss font-mono pb-20 md:pb-0">
                    <p data-testid="footer-copyright">
                        © {year} {BUSINESS.name} — {BUSINESS.location}
                    </p>
                    <p className="flex flex-wrap gap-x-3">
                        <span>Ground 6–8" below grade · Same-week guarantee</span>
                        <Link to="/admin" data-testid="footer-owner-login" className="hover:text-brand-amber transition-colors">
                            Owner login
                        </Link>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
